import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        طراحی شده توسط 
        <a href="https://navaweb.net" target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">شرکت نوا وب</a>
    </div>`
})
export class AppFooter {}
